import { Injectable } from '@angular/core';
import { AbstractCrudService } from '../service/abstract.crud.service';

@Injectable({
  providedIn: 'root'
})
export class FeriadoService extends AbstractCrudService {

  protected getBaseUrlPrivate(): string {
    return super.getBaseUrlPrivate() + 'feriados';
  }

  protected getBaseUrlPublic(): string {
    throw new Error("Método não suportado!");
  }

}
